import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import {
  ScrollContext
} from 'react-router-scroll-4'
import {
  Container,
  Header,
} from 'semantic-ui-react'
import ScrollBehavior from 'scroll-behavior';
import PageHeader from './PageHeader'
import PageFooter from './PageFooter'
import Home from './Home.js'
import Contact from './Contact.js'
import Terms from './Terms.js'
import Privacy from './Privacy.js'
import Mistakes from './Mistakes.js'
import Conversion from './Conversion.js'
import Ids from './Ids.js'
import Areas from './Areas.js'
import Units from './Units.js'
import Outcomes from './Outcomes.js'
import Search from './Search.js'
import Area from './Area.js'
import Unit from './Unit.js'
import Selections from './Selections.js'
import ViewSelection from './ViewSelection.js'
import ExportSelection from './ExportSelection.js'
import ImportSelection from './ImportSelection.js'
import ImportSelectionViaPaste from './ImportSelectionViaPaste'
import Invitation from './Invitation.js'
import NewSelection from './NewSelection.js'
import RequestSelection from './RequestSelection.js'
import SelectionSettings from './SelectionSettings.js'
import NoMatch from './NoMatch'
import SelectFooter from './SelectFooter'
import CompareFooter from './CompareFooter'
import SelectionModeSwitcher from './SelectionModeSwitcher.js'
import typePresets from './typePresets.js'
import { cloneType } from './type.js'
import { version, upgradeSelectionIfNeeded } from './curriculum.js'
import { isAreaId, isUnitId, isItemId, getAreaId, getUnitId } from './utils';

const basename = "/assets/cc13";



class CenterScrollBehavior extends ScrollBehavior {
  scrollToTarget(element, target) {
    console.log("CenterScrollBehavior::scrollToTarget()", element, target);
    if (element !== window) {
      super.scrollToTarget(element, target);
      return;
    }

    if (typeof target === 'string') {
      const targetElement = (
        document.getElementById(target) ||
        document.getElementsByName(target)[0]
      );
      if (targetElement) {
        console.log("CenterScrollBehavior::scrollToTarget() # ", targetElement);

        const rect = targetElement.getBoundingClientRect();
        console.log("rect:", rect);
        var scrollTop = document.documentElement.scrollTop?
                        document.documentElement.scrollTop:document.body.scrollTop;
        var scrollLeft = document.documentElement.scrollLeft?
                         document.documentElement.scrollLeft:document.body.scrollLeft;
        console.log("scrollTop:", scrollTop);
        const elementTop = rect.top+scrollTop;
        console.log("elementTop:", elementTop);
        const elementLeft = rect.left+scrollLeft;
        //HACK: scroll so the element is 10 pixels below the 57-pixel high menu bar
        window.scrollTo({top: elementTop-57-10, left: elementLeft});
        //targetElement.scrollIntoView({ block: 'center' });
        return;
      }

      // Fallback to scrolling to top when target fragment doesn't exist.
      target = [0, 0]; // eslint-disable-line no-param-reassign
    }

    const [left, top] = target;
    window.scrollTo({ left, top });
  }
}




class App extends React.Component {
  state = {
    mode: 'view',
    comparisonMode: 'overallBarsPercent',
    selections: [],
    currentSelectionName: null,
    comparisonSelectionNames: [],
    typePresets: [...typePresets]
  }
  createEmptySelection = () => {
    const ids = this.state.selections.map(s=>s.id);
    let i = 1;
    function exists(nid) { return ids.find(id=>id===nid); }
    while (exists('MY'+i)) {
      i++;
    }
    return {
      id: 'MY'+i,
      name: 'My Selection '+i,
      author: '',
      description: '',
      date: new Date().toUTCString(),
      version: version,
      items: {},
      type: cloneType(typePresets[0])
    };
  }
  handleModeChange = (mode) => {
    console.log("App::handleModeChange()", mode);
    this.setState(prevState => {
      let name = prevState.currentSelectionName;
      if (mode==='select' && name==null && prevState.selections.length) {
        name = prevState.selections[0].id;
      }
      localStorage.setItem("currentSelectionId", JSON.stringify(name));
      localStorage.setItem("mode", JSON.stringify(mode));
      return {
        mode,
        currentSelectionName: name
      };
    });
  }
  handlePickSelection = (value) => {
    console.log("App::handlePickSelection()", value);
    this.setState(prevState => {
      console.log("prevSate:", prevState);
      const s = prevState.selections.find(s=>s.id===value);
      console.log("s:", s);
      const sid = s?value:null;
      localStorage.setItem("currentSelectionId", JSON.stringify(sid));
      localStorage.setItem("mode", JSON.stringify('select'));
      return {
        currentSelectionName: sid,
        mode: 'select'
      };
    });
  }
  handlePickComparisonSelections = (value) => {
    console.log("App::handlePickComparisonSelections()", value);
    localStorage.setItem("comparisonSelectionNames", JSON.stringify(value));
    this.setState({
      comparisonSelectionNames: value
    });
  }
  handlePickComparisonMode = (value) => {
    console.log("App::handlePickComparisonMode()", value);
    localStorage.setItem("comparisonMode", JSON.stringify(value));
    this.setState({
      comparisonMode: value,
    });
  }
  handleImportSelection = (selection) => {
    console.log("App::handleImportSelection()", selection);
    selection = upgradeSelectionIfNeeded(selection);
    this.setState(prevState => {
      const newSelections = [...prevState.selections, selection];
      localStorage.setItem("selections", JSON.stringify(newSelections));
      localStorage.setItem("currentSelectionId", JSON.stringify(selection.id));
      localStorage.setItem("mode", JSON.stringify('select'));
      return {
        selections: newSelections,
        currentSelectionName: selection.id,
        mode: 'select'
      }
    });
  }
  handleNewSelection = (selection) => {
    console.log("App::handleNewSelection()", selection);
    this.setState(prevState => {
      const newSelections = [...prevState.selections, selection];
      localStorage.setItem("selections", JSON.stringify(newSelections));
      localStorage.setItem("currentSelectionId", JSON.stringify(selection.id));
      localStorage.setItem("mode", JSON.stringify('select'));
      return {
        selections: newSelections,
        currentSelectionName: selection.id,
        mode: 'select'
      }
    });
  }
  handleUpdateSelectionSettings = (id, selection) => {
    console.log("App::handleUpdateSelectionSettings()", id, selection);
    this.setState(prevState => {
      const sNew = {...selection};
      console.log("prevSate:", prevState);
      const ssOld = prevState.selections;
      console.log("ssOld:", ssOld);
      const ssNew = ssOld.map((s, i)=>s.id===id?sNew:s);
      console.log("ssNew:", ssNew);
      localStorage.setItem("selections", JSON.stringify(ssNew));
      localStorage.setItem("currentSelectionId", JSON.stringify(selection.id));
      localStorage.setItem("mode", JSON.stringify('select'));
      return {
        selections: ssNew,
        currentSelectionName: selection.id,
        mode: 'select'
        };
    });
  }
  handleToggle = (fqid, eid, cid) => {
    console.log("App::handleToggle()", fqid);
    this.setState(prevState => {
      console.log("prevSate:", prevState);
      const ss = [...prevState.selections];
      const sOld = ss.find(s=>s.id===prevState.currentSelectionName);
      console.log("sOld:", sOld);
      const sNew = {...sOld};
      sNew.items = {...sNew.items};
      const oldItem = sNew.items[fqid]||{};
      const newItem = {...oldItem};
      if (newItem[eid]===cid) {
        delete newItem[eid];
      } else {
        newItem[eid] = cid;
      }
      if (Object.keys(newItem).length) {
        sNew.items[fqid] = newItem;
      } else {
        delete sNew.items[fqid];
      }
      console.log("sNew:", sNew);
      const ssNew = ss.map((s, i)=>s.id===prevState.currentSelectionName?sNew:s);
      console.log("ssNew:", ssNew);
      localStorage.setItem("selections", JSON.stringify(ssNew));
      return {
        selections: ssNew
      };
    });
  }
  handleDeleteSelection = (id) => {
    console.log("App::handleDeleteSelection()", id);
    this.setState(prevState => {
      console.log("prevSate:", prevState);
      const ssOld = prevState.selections;
      console.log("ssOld:", ssOld);
      const ssNew = ssOld.filter(s=>{console.log('s', s, 'id', id, 's.id!==id', s.id!==id); return s.id!==id});
      console.log("ssNew:", ssNew);
      const current = ssNew.length?ssNew[0].id:null;
      localStorage.setItem("selections", JSON.stringify(ssNew));
      localStorage.setItem("currentSelectionId", JSON.stringify(current));
      localStorage.setItem("mode", JSON.stringify('select'));
      return {
        selections: ssNew,
        currentSelectionName: current,
        mode: 'select'
        };
    });
  }
  hydrateStateWithLocalStorage() {
    console.log("App::hydrateStateWithLocalStorage()");
    // used "currentSelectionName" throughout the app,
    // but really should be using "currentSelectionId"
    if (localStorage.hasOwnProperty('currentSelectionId')) {
      let value = localStorage.getItem('currentSelectionId');
      try {
        value = JSON.parse(value);
        this.setState({ currentSelectionName: value });
      } catch (e) {
        // handle empty string
        this.setState({ currentSelectionName: value });
      }
    }

    // for all items in state
    for (let key in this.state) {
      // if the key exists in localStorage
      if (localStorage.hasOwnProperty(key)) {
        // get the key's value from localStorage
        let value = localStorage.getItem(key);
        // parse the localStorage string and setState
        try {
          value = JSON.parse(value);
          if (key==='selections') {
            //console.log("selections (before upgrade):", value);
            // possibly upgrade selections
            value = value.map(s=>upgradeSelectionIfNeeded(s));
            //console.log("selections (after upgrade):", value);
          }
          this.setState({ [key]: value });
        } catch (e) {
          // handle empty string
          this.setState({ [key]: value });
        }
      }
    }
  }
  componentDidMount() {
    this.hydrateStateWithLocalStorage();
  }
  render() {
    return (
      <Router basename={basename}>
        <ScrollContext scrollBehavior={CenterScrollBehavior} shouldUpdateScroll={
          (prevRouterProps, { location, history }) => {
            console.log("shouldUpdateScroll()", prevRouterProps, location, history);
             return !prevRouterProps || (prevRouterProps && location.pathname !== prevRouterProps.location.pathname);
          }
        }>
          <div>
            <PageHeader mode={this.state.mode} onModeChange={this.handleModeChange}/>
            <Switch>
              <Route exact path="/" render={(props)=>
                <Home
                  {...props}
                  mode={this.state.mode}
                  onSelect={()=>this.handleModeChange('select')}
                />
              }/>
              <Route exact path="/contact" component={Contact}/>
              <Route exact path="/terms" component={Terms}/>
              <Route exact path="/privacy" component={Privacy}/>
              <Route exact path="/conversion/process" render={(props)=>
                <Conversion
                  {...props}
                  basename={basename}
                />
              }/>
              <Route exact path="/conversion/mistakes" component={Mistakes}/>
              <Route exact path="/conversion/ids" component={Ids}/>
              <Route exact path="/areas" render={(props)=>
                <Areas
                  {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                />
              }/>
              <Route exact path="/units" render={(props)=>
                <Units
                  {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                />
              }/>
              <Route exact path="/outcomes" component={(props)=>
                <Outcomes
                {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                  onToggle={this.handleToggle}
                />
              }/>
              <Route exact path="/search" render={(props)=>
                <Search
                  {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                  onToggle={this.handleToggle}
                />
              }/>
              <Route exact path="/area/:id" render={(props)=>
                <Area
                  {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                />
              }/>
              <Route exact path="/unit/:areaid/:unitname" render={(props)=>
                <Unit
                  {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                  onToggle={this.handleToggle}
                />
              }/>
              <Route exact path="/unit/:unitfqid" render={(props)=>
                <Unit
                  {...props}
                  mode={this.state.mode}
                  selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                  selections={this.state.selections}
                  comparisonMode={this.state.comparisonMode}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                  onToggle={this.handleToggle}
                />
              }/>
              <Route exact path="/fqid/:fqid" render={(props)=>{
                const fqid = props.match.params.fqid;
                if (isAreaId(fqid)) {
                  return <Redirect to={"/area/"+fqid}/>
                } else if (isUnitId(fqid)) {
                  return <Redirect to={"/unit/"+fqid}/>
                } else if (isItemId(fqid)) {
                  /*
                  const newMatch = {...props.match};
                  newMatch.params = {
                    unitfqid: fqid,
                  }
                  const newLocation = {...props.location};
                  newLocation.hash = '#'+fqid;
                  const newProps = {...props, match: newMatch, location: newLocation};
                  return (
                    <Unit
                      {...newProps}
                      mode={this.state.mode}
                      selection={this.state.selections.find(s=>s.id===this.state.currentSelectionName)}
                      selections={this.state.selections}
                      comparisonMode={this.state.comparisonMode}
                      comparisonSelectionNames={this.state.comparisonSelectionNames}
                      onToggle={this.handleToggle}
                    />
                  );
                  */
                  return <Redirect to={"/unit/"+getAreaId(fqid)+getUnitId(fqid)+"#"+fqid}/>;
                } else {
                  return (
                    <Container text style={{ marginTop: '7em' }}>
                      <Header as='h1'>Unknown FQID</Header>
                      <p>
                        {fqid} is not a fully-qualified ID
                        for an area, unit, topic, or learning outcome
                        of the curriculum.
                      </p>
                    </Container>
                  );
                }
              }}/>
              <Route exact path="/selections" render={(props)=>
                <Selections
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  currentSelectionName={this.state.currentSelectionName}
                  onPickSelection={this.handlePickSelection}
                />
              }/>
              <Route exact path="/selection/:selectionName/export" render={(props)=>
                <ExportSelection
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                />
              }/>
              <Route exact path="/selection/:selectionName/settings" render={(props)=>
                <SelectionSettings
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  typePresets={this.state.typePresets}
                  onUpdate={this.handleUpdateSelectionSettings}
                  onDelete={this.handleDeleteSelection}
                />
              }/>
              <Route exact path="/selection/:selectionName" render={(props)=>
                <ViewSelection
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  onToggle={this.handleToggle}
                  onPickSelectionMode={()=>this.handleModeChange('select')}
                />
              }/>
              <Route exact path="/import-selection" render={(props)=>
                <ImportSelection
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  onImport={this.handleImportSelection}
                />
              }/>
              <Route exact path='/import-selection-via-paste' render={(props)=>
                <ImportSelectionViaPaste
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  onImport={this.handleImportSelection}
                />
              }/>
              <Route exact path="/invite" render={(props)=>
                <Invitation
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  onImport={this.handleImportSelection}
                />
              }/>
              <Route exact path="/new-selection" render={(props)=>
                <NewSelection
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  selection={this.createEmptySelection()}
                  typePresets={this.state.typePresets}
                  onCreate={this.handleNewSelection}
                />
              }/>
              <Route exact path="/request-selection" render={(props)=>
                <RequestSelection
                  {...props}
                  mode={this.state.mode}
                  selections={this.state.selections}
                  selection={this.createEmptySelection()}
                  typePresets={this.state.typePresets}
                />
              }/>
              <Route component={NoMatch}/>
            </Switch>
            <SelectionModeSwitcher
              onSelect={()=>this.handleModeChange('select')}
              onPickSelection={this.handlePickSelection}
            />
            <PageFooter basename={basename}/>
            {
              this.state.mode==='select'
              ?
                <SelectFooter
                  selections={this.state.selections}
                  currentSelectionName={this.state.currentSelectionName}
                  onPickSelection={this.handlePickSelection}
                />
              :
                undefined
            }
            {
              this.state.mode==='compare'
              ?
                <CompareFooter
                  comparisonMode={this.state.comparisonMode}
                  selections={this.state.selections}
                  comparisonSelectionNames={this.state.comparisonSelectionNames}
                  onPickComparisonSelections={this.handlePickComparisonSelections}
                  onPickComparisonMode={this.handlePickComparisonMode}
                />
              :
                undefined
            }
          </div>
        </ScrollContext>
      </Router>
    );
  }
}

export default App